import { Typography } from '@mui/material'

const GameTitle = () =>
    <Typography variant="h3" component="div">
        The Hangman
    </Typography>

export default GameTitle
